import { inject, Injectable } from '@angular/core';
import { AuthStore2 } from '@seatix/shared/data-access/auth';
import {
  BYPASS_ROLES,
  GateValidationBypassChecker,
  provideGateValidationBypassChecker,
} from './gate-validation.provider';

/**
 * Default role-based bypass checker for gate validation.
 * Checks if the current user has any of the configured bypass roles.
 */
@Injectable()
export class RoleBypassChecker implements GateValidationBypassChecker {
  readonly #authStore = inject(AuthStore2);
  readonly #bypassRoles = inject(BYPASS_ROLES);

  canBypass(): boolean {
    const user = this.#authStore.user();
    console.log(user?.roles);
    if (!user?.roles?.length) return false;

    return user.roles.some((role) => this.#bypassRoles.includes(role));
  }
}

/**
 * Provides RoleBypassChecker as the gate validation bypass implementation.
 *
 * @example
 * // In app.config.ts
 * providers: [
 *   provideGateValidationBypass(['owner', 'manager']),
 *   provideRoleBypassChecker(),
 * ]
 */
export function provideRoleBypassChecker() {
  return [provideGateValidationBypassChecker(() => new RoleBypassChecker())];
}
